import services from '../../../services'

const state = {
}

const actions = {
  async roleList ({ commit }, query) {
    return await services.role_query(query)
  },

  async roleTemplate ({ commit }, query) {
    return await services.role_template(query)
  },

  async getRole ({ commit }, id) {
    let params = {
      id: id
    }
    return await services.role_getRole({params: params})
  },
  async addRole ({ commit }, options) {
    return await services.role_add(options)
  },
  async updateRole ({ commit }, options) {
    return await services.role_update(options.id, options)
  },
  async deleteRole ({ commit }, id) {
    let params = {
      roleId: id
    }
    return await services.role_delete({params: params})
  }
}

const mutations = {
}
export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/system/role.js